import { useT } from '../../providers/I18nProvider.js';

/** Shown when the app is opened outside of Telegram in production. */
export function NotInTelegramScreen(): JSX.Element {
  const t = useT();
  return (
    <div className="status-screen">
      <div className="status-screen__logo">✦</div>
      <div className="status-screen__title">{t('auth.notInTelegram')}</div>
      <div className="status-screen__text muted">{t('auth.notInTelegramHint')}</div>
    </div>
  );
}
